<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="pages" class="filter-panel fl">
				<el-form-item>
					<el-select v-model="pages.type" class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in type_list" :key="index" :label="lang=='cn'?item.cn:item.en" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="sousuo">{{$t('index.query')}}</el-button>
					<el-button type="" size="mini" @click="chongxzhi">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="course_id" align="center" label="ID" data-name="人数" width="100px"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('virtual.subject')" data-nam="主题"></el-table-column>
			<el-table-column prop="all_num" align="center" :label="$t('virtual.number')" data-name="人数" width="100px">
				<template slot-scope="scope"> {{scope.row.class_num}} / {{scope.row.all_class_num}} </template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="650px">
				<template slot-scope="scope">
					<div class="panioanj">
						<el-badge :is-dot="scope.row.teacher_leave_num>0" class="item">
							<el-button size="mini" type="primary" @click="userLeaveList(scope.row,'teacher')" data-name="老师请假">{{$t('virtual.teacher')}}</el-button>
						</el-badge>
						<el-badge :is-dot="scope.row.user_leave_num>0" class="item">
							<el-button size="mini" type="primary" @click="userLeaveList(scope.row,'user')" data-name="学生请假">{{$t('virtual.student')}}</el-button>
						</el-badge>
						<el-badge :is-dot="scope.row.assess_num>0" class="item">
							<el-button size="mini" type="primary" @click="evaluate_f(scope.row)" data-name="查看点评">{{$t('virtual.comment')}}</el-button>
						</el-badge>
						<el-badge :is-dot="scope.row.opinion_num>0" class="item">
							<el-button size="mini" type="primary" @click="feedback_f(scope.row)" data-name="意见反馈">{{$t('virtual.feedback')}}</el-button>
						</el-badge>
						<el-button size="mini" type="primary" @click="virtualmaillist_f(scope.row)" data-name="公/私信">{{$t('virtual.private')}}</el-button>
						<el-button size="mini" type="primary" @click="messageRecord_f(scope.row)" data-name="师生交流">{{$t('virtual.chat')}}</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<leave :editFormVisible="editFormVisible" :course_type="course_type" :user_type="user_type" :course_id="course_id" @guanbitanchu="editFormVisible=false"></leave>
		<feedback :editFormVisible="feedback_is" :course_type="course_type" :course_id="course_id" @guanbitanchu="feedback_is=false"></feedback>
		<evaluate :editFormVisible="evaluate_is" :course_type="course_type" :course_id="course_id" @guanbitanchu="evaluate_is=false"></evaluate>
		<communication :editFormVisible="messageRecord_is" :course_type="course_type" :course_id="course_id" @guanbitanchu="messageRecord_is=false"></communication>
		<virtualmaillist :editFormVisible="virtualmaillist_is" :course_type="course_type" :course_id="course_id" @guanbitanchu="virtualmaillist_is=false"></virtualmaillist>
	   
	</div>
</template>
<script>
import leave from '../../components/leave.vue'
import feedback from '../../components/feedback.vue'
import evaluate from '../../components/evaluate.vue'
import communication from '../../components/communication.vue'
import virtualmaillist from '../../components/virtualmaillist.vue'
export default {
	components: {
		leave,
		evaluate,
		communication,
		virtualmaillist,
		feedback
	},
	data() {
		return {
			list: [],
			course_type: 'course',
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
				type: '',
			},
			type_list: [{
				cn: '进行中',
				en: 'have in hand',
				id: 'current',
			}, {
				cn: '已结束',
				en: "It's over",
				id: 'finish',
			}],
			editFormVisible:false,
			feedback_is:false,
			evaluate_is:false,
			messageRecord_is:false,
			virtualmaillist_is:false,
			// teacher_list:[],
			course_id:'',
			user_type:'',
		}
	},
	// 初始事件
	mounted: function () {
		var path=this.$route.path;
		if (path=='/virtual_course') {
			this.course_type='course';
		}else{
			this.course_type='camp';
		}
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			if (this_.course_type=='course') {
				var url = "adminCourseClass";
			}else{
				var url = "adminCampClass";
			}
			var datas = {
				type: this_.pages.type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		userLeaveList(data,type){
			this.course_id=String(data.course_id);
			this.user_type=type;
			this.editFormVisible=true;
		},
		feedback_f(data){
			this.course_id=String(data.course_id);
			this.feedback_is=true;
		},
		evaluate_f(data){
			this.course_id=String(data.course_id);
			this.evaluate_is=true;
		},
		messageRecord_f(data){
			this.course_id=String(data.course_id);
			this.messageRecord_is=true;
		},
		virtualmaillist_f(data){
			this.course_id=String(data.course_id);
			this.virtualmaillist_is=true;
		},
		// 搜索
		sousuo() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		chongxzhi() {
			this.pages.type = '';
			this.pages.page = 1;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	/* margin-bottom: 22px; */
}
.page-pagination {
	padding: 20px 10px;
}
.panioanj{
	padding: 10px 0;
}
.item{
	margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/virtual/camp.vue